import AurDataGridCellWrapper from '../../common/aur-data-grid/AurDataGridCellWrapper';
import WorkspaceStatusCell from './WorkspaceStatusCell';
import styles from '../../../styles/components/clientdetails/projectDrawerStyle.module.scss';
import {getUTCDateTimeForDisplay} from '../../../utils/utils';
import {t} from 'i18next';
import {ONLY_DATE_SHOW_FORMAT} from '../../../constants/constants';
import {CustomGridColDef} from '../../common/aur-data-grid-pro/AurDataGridPro';

export const getWorkspaceTableColumnDef = (): CustomGridColDef[] => [
  {
    field: 'workspaceCode',
    headerName: t('common.workspaceTable.id'),
    headerClassName: `${styles.worksapceIdColumnHeader}`,
    flex: 1,
    sortable: false,
    renderCell: (params) => (
      <AurDataGridCellWrapper
        cellData={params.value}
        className={`${styles.projectDetailsWorkspacesFirstColumnCell}`}
        ellipsisDisabled={true}
        tooltipDisabled={true}
      />
    ),
  },
  {
    field: 'workspaceName',
    headerName: t('common.workspaceTable.workspaceName'),
    flex: 2,
    sortable: false,
    renderCell: (params) => (
      <AurDataGridCellWrapper
        ellipsisDisabled={true}
        tooltipDisabled={true}
        cellData={params.value}
      />
    ),
  },
  {
    field: 'hostingPlatform',
    headerName: t('common.workspaceTable.platform'),
    flex: 1,
    sortable: false,
  },
  {
    field: 'createdOn',
    headerName: t('common.workspaceTable.created'),
    flex: 1,
    sortable: false,
    isDateColumn: true,
    renderCell: (param) => (
      <span>
        {getUTCDateTimeForDisplay(param.value, ONLY_DATE_SHOW_FORMAT)}
      </span>
    ),
  },
  {
    field: 'status',
    headerName: t('common.workspaceTable.status'),
    flex: 1,
    sortable: false,
    renderCell: (params) => (
      <AurDataGridCellWrapper
        ellipsisDisabled={true}
        tooltipDisabled={true}
        cellData={params.value}
        customCellContent={
          <WorkspaceStatusCell
            cellText={params.value}
            iconType={params.value}
          />
        }
      />
    ),
  },
];
